export default "{\n    \"placeholderText\": \"Sélectionner la plage de dates\"\n}\n"